import React from 'react';

/**
 * ProductList 컴포넌트 속성 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const ProductListProperties = [
  {
    group: '레이아웃 설정',
    properties: [
      {
        name: 'componentProps.order',
        label: '순서',
        control: 'TextField',
        defaultValue: ''
      },
      {
        name: 'componentProps.lg',
        label: '그리드 크기(lg)',
        control: 'Slider',
        min: 1,
        max: 12,
        step: 1,
        defaultValue: 12
      },
      {
        name: 'componentProps.className',
        label: 'CSS 클래스',
        control: 'TextField',
        defaultValue: 'padding-tb-40'
      },
      {
        name: 'componentProps.itemsPerRow',
        label: '한 줄당 상품 수',
        control: 'Select',
        options: [
          { value: 2, label: '2개' },
          { value: 3, label: '3개' },
          { value: 4, label: '4개' },
          { value: 6, label: '6개' }
        ],
        defaultValue: 4
      }
    ]
  },
  {
    group: '상품 필터링',
    properties: [
      {
        name: 'componentProps.categoryId',
        label: '카테고리 ID',
        control: 'TextField',
        defaultValue: ''
      },
      {
        name: 'componentProps.include_product_ids',
        label: '포함할 상품 ID (콤마로 구분)',
        control: 'TextField',
        defaultValue: ''
      },
      {
        name: 'componentProps.exclude_product_ids',
        label: '제외할 상품 ID (콤마로 구분)',
        control: 'TextField',
        defaultValue: ''
      },
      {
        name: 'componentProps.include_category_ids',
        label: '포함할 카테고리 ID (콤마로 구분)',
        control: 'TextField',
        defaultValue: ''
      },
      {
        name: 'componentProps.exclude_category_ids',
        label: '제외할 카테고리 ID (콤마로 구분)',
        control: 'TextField',
        defaultValue: ''
      },
      {
        name: 'componentProps.excludeIndexes',
        label: '제외할 인덱스 (콤마로 구분)',
        control: 'TextField',
        defaultValue: ''
      }
    ]
  },
  {
    group: '표시 설정',
    properties: [
      {
        name: 'componentProps.showStock',
        label: '재고 표시',
        control: 'Checkbox',
        defaultValue: false
      },
      {
        name: 'componentProps.itemsPerPage',
        label: '페이지당 아이템 수',
        control: 'NumberField',
        min: 1,
        max: 100,
        defaultValue: 20
      }
    ]
  },
  {
    group: '스타일 설정',
    properties: [
      {
        name: 'style.backgroundColor',
        label: '배경색',
        control: 'ColorPicker',
        defaultValue: 'transparent'
      },
      {
        name: 'style.padding',
        label: '여백',
        control: 'TextField',
        defaultValue: '0px'
      },
      {
        name: 'style.borderRadius',
        label: '테두리 둥글기',
        control: 'TextField',
        defaultValue: '0px'
      }
    ]
  }
];

export default ProductListProperties; 